import Navbar from './home/components/Navbar';
import Footer from './home/components/Footer';
import RegisterLink from '../components/RegisterLink';
import { useLanguage } from '../contexts/LanguageContext';
import { Link } from 'react-router-dom';
import { usePageSeo } from '../hooks/usePageSeo';
import { LinkedText } from '../components/LinkedText';

const trustStats = [
  { num: '500K+', en_label: 'Active Players', bm_label: 'Pemain Aktif' },
  { num: '5,000+', en_label: 'Casino Games', bm_label: 'Permainan Kasino' },
  { num: '4', en_label: 'Active Bonuses', bm_label: 'Bonus Aktif' },
  { num: '24/7', en_label: 'Live Support', bm_label: 'Sokongan Langsung' },
];

const features = [
  {
    icon: 'ri-shield-check-fill',
    color: '#d4a017',
    en_title: 'Licensed & Trusted',
    bm_title: 'Berlesen & Dipercayai',
    en_desc:
      "MrCuci operates under a legitimate gaming licence, ensuring every game is fair and every transaction is protected. Malaysia's players have trusted us since day one because transparency is non-negotiable.",
    bm_desc:
      'MrCuci beroperasi di bawah lesen permainan yang sah, memastikan setiap permainan adalah adil dan setiap transaksi dilindungi. Pemain Malaysia telah mempercayai kami sejak hari pertama kerana ketelusan adalah wajib.',
  },
  {
    icon: 'ri-gift-2-fill',
    color: '#cc1100',
    en_title: 'Most Bonuses in Malaysia',
    bm_title: 'Bonus Terbanyak di Malaysia',
    en_desc:
      'From New Member Register Free RM88 and Welcome Bonus 50% to Deposit RM200 Free RM200 and Monthly Competition Deposit Ranking RM1088, no platform in Malaysia matches the depth of MrCuci promotions.',
    bm_desc:
      'Dari Ahli Baharu Daftar Percuma RM88 dan Bonus Selamat Datang 50% hingga Deposit RM200 Percuma RM200 dan Pertandingan Bulanan Kedudukan Deposit RM1088, tiada platform di Malaysia yang menandingi kedalaman promosi MrCuci.',
  },
  {
    icon: 'ri-flashlight-fill',
    color: '#d4a017',
    en_title: 'Instant Withdrawals',
    bm_title: 'Pengeluaran Segera',
    en_desc:
      "We process withdrawals faster than any other Malaysian online casino. Most payouts arrive within minutes, not hours, not days. Your winnings are yours, and we make sure you get them fast.",
    bm_desc:
      'Kami memproses pengeluaran lebih pantas daripada mana-mana kasino dalam talian Malaysia yang lain. Kebanyakan bayaran tiba dalam beberapa minit, bukan jam, bukan hari. Kemenangan anda adalah milik anda, dan kami pastikan anda menerimanya dengan cepat.',
  },
  {
    icon: 'ri-smartphone-fill',
    color: '#cc1100',
    en_title: 'Mobile-First Experience',
    bm_title: 'Pengalaman Mengutamakan Mudah Alih',
    en_desc:
      'MrCuci is built for Malaysian players on the go. Our platform runs flawlessly on any device, phone, tablet, or desktop, with no app download required. Play any game, claim any bonus, withdraw anytime.',
    bm_desc:
      'MrCuci dibina untuk pemain Malaysia yang sentiasa bergerak. Platform kami berjalan dengan sempurna pada mana-mana peranti, telefon, tablet, atau desktop, tanpa perlu memuat turun aplikasi. Main mana-mana permainan, tuntut mana-mana bonus, keluarkan wang bila-bila masa.',
  },
  {
    icon: 'ri-bank-card-fill',
    color: '#d4a017',
    en_title: 'All Malaysian Payment Methods',
    bm_title: 'Semua Kaedah Pembayaran Malaysia',
    en_desc:
      'Deposit and withdraw using FPX, MEPS, Touch n\' Go eWallet, GrabPay, Digi, Hotlink, and more. Every major Malaysian payment channel is supported with zero transaction fees on your end.',
    bm_desc:
      "Deposit dan keluarkan menggunakan FPX, MEPS, Touch n' Go eWallet, GrabPay, Digi, Hotlink, dan banyak lagi. Setiap saluran pembayaran utama Malaysia disokong tanpa sebarang fi transaksi di pihak anda.",
  },
  {
    icon: 'ri-customer-service-2-fill',
    color: '#cc1100',
    en_title: '24/7 Bilingual Support',
    bm_title: 'Sokongan Dwibahasa 24/7',
    en_desc:
      'Our customer support team is available around the clock in both English and Bahasa Malaysia. Whether you have a question about a bonus, a withdrawal, or a game, we respond fast and resolve faster.',
    bm_desc:
      'Pasukan sokongan pelanggan kami tersedia sepanjang masa dalam Bahasa Inggeris dan Bahasa Malaysia. Sama ada anda mempunyai soalan tentang bonus, pengeluaran, atau permainan, kami bertindak balas dengan cepat dan menyelesaikan dengan lebih cepat.',
  },
];

const milestones = [
  {
    year: '2019',
    en_title: 'MrCuci Founded',
    bm_title: 'MrCuci Ditubuhkan',
    en_desc: 'Launched with a focused mission: build the most player-friendly online casino in Malaysia.',
    bm_desc: 'Dilancarkan dengan misi yang jelas: membina kasino dalam talian yang paling mesra pemain di Malaysia.',
  },
  {
    year: '2020',
    en_title: '100,000 Players',
    bm_title: '100,000 Pemain',
    en_desc: 'Reached 100,000 registered members within the first year, driven entirely by word of mouth.',
    bm_desc: 'Mencapai 100,000 ahli berdaftar dalam tahun pertama, didorong sepenuhnya oleh cadangan mulut ke mulut.',
  },
  {
    year: '2022',
    en_title: '5,000+ Games Added',
    bm_title: '5,000+ Permainan Ditambah',
    en_desc: 'Expanded the game lobby to over 5,000 titles across slots, live casino, sports, and more.',
    bm_desc: 'Meluaskan lobi permainan kepada lebih 5,000 tajuk merentasi slot, kasino langsung, sukan, dan banyak lagi.',
  },
  {
    year: '2024',
    en_title: '500,000 Active Players',
    bm_title: '500,000 Pemain Aktif',
    en_desc: 'Half a million active Malaysian players, cementing MrCuci as the #1 trusted online casino in Malaysia.',
    bm_desc: 'Setengah juta pemain Malaysia aktif dahukuhkan MrCuci sebagai kasino dalam talian #1 yang dipercayai di negara ini.',
  },
];

const values = [
  {
    icon: 'ri-eye-fill',
    en_title: 'Transparency',
    bm_title: 'Ketelusan',
    en_desc: 'Clear bonus terms, fair game outcomes, and honest communication — always.',
    bm_desc: 'Terma bonus yang jelas, hasil permainan yang adil, dan komunikasi yang jujur — sentiasa.',
  },
  {
    icon: 'ri-heart-fill',
    en_title: 'Player First',
    bm_title: 'Pemain Dahulu',
    en_desc: 'Every decision we make is guided by what is best for the player experience.',
    bm_desc: 'Setiap keputusan yang kami buat dipandu oleh apa yang terbaik untuk pengalaman pemain.',
  },
  {
    icon: 'ri-lock-fill',
    en_title: 'Security',
    bm_title: 'Keselamatan',
    en_desc: 'Bank-grade encryption and strict data privacy standards protect every account.',
    bm_desc: 'Penyulitan gred bank dan piawaian privasi data yang ketat melindungi setiap akaun.',
  },
  {
    icon: 'ri-seedling-fill',
    en_title: 'Responsible Gambling',
    bm_title: 'Perjudian Bertanggungjawab',
    en_desc: 'We actively promote healthy gaming habits and provide tools to help players stay in control.',
    bm_desc: 'Kami secara aktif mempromosikan tabiat permainan yang sihat dan menyediakan alat untuk membantu pemain kekal terkawal.',
  },
];

export default function AboutPage() {
  const { lang, t } = useLanguage();
  const title = t(
    'About MrCuci Malaysia Online Casino | Games, Bonuses & Trust',
    'Tentang Kasino Dalam Talian MrCuci Malaysia | Permainan, Bonus & Kepercayaan'
  );
  const description = t(
    'Learn about MrCuci Malaysia online casino, including its 5,000+ games, MYR payment methods, current bonuses, mobile experience and player support.',
    'Kenali kasino dalam talian MrCuci Malaysia termasuk 5,000+ permainan, kaedah pembayaran MYR, bonus semasa, pengalaman mudah alih dan sokongan pemain.'
  );

  usePageSeo({
    title,
    description,
    path: '/about/',
    language: lang === 'bm' ? 'ms-MY' : 'en-MY',
    keywords: [
      'About MrCuci',
      'MrCuci Malaysia',
      'MrCuci online casino review',
      'trusted online casino Malaysia',
      'best casino Malaysia',
      'Malaysia casino platform',
      'MrCuci payment methods',
      'MrCuci withdrawal',
      'MrCuci customer support',
      'kasino dalam talian dipercayai Malaysia',
    ],
    schema: {
      '@context': 'https://schema.org',
      '@type': 'AboutPage',
      '@id': 'https://www.mrcuci.me/about/#webpage',
      url: 'https://www.mrcuci.me/about/',
      name: title,
      description,
      inLanguage: lang === 'bm' ? 'ms-MY' : 'en-MY',
      isPartOf: { '@id': 'https://www.mrcuci.me/#website' },
      mainEntity: {
        '@type': 'Organization',
        '@id': 'https://www.mrcuci.me/#organization',
        name: 'MrCuci',
        url: 'https://www.mrcuci.me/',
        logo: 'https://www.mrcuci.me/favicon.png',
        areaServed: { '@type': 'Country', name: 'Malaysia' },
        knowsLanguage: ['en-MY', 'ms-MY'],
      },
    },
  });

  return (
    <div className="min-h-screen bg-[#080000] font-sans">
      <Navbar />

      <main className="pt-20">

        {/* Hero */}
        <section
          className="py-16 md:py-24 border-b border-[#d4a017]/10 relative overflow-hidden"
          style={{ background: 'linear-gradient(135deg, #0d0000 0%, #1a0303 55%, #0d0000 100%)' }}
        >
          <div
            className="absolute inset-0 opacity-10"
            style={{ background: 'radial-gradient(ellipse 80% 60% at 60% 50%, #cc1100, transparent)' }}
          />
          <div className="max-w-7xl mx-auto px-4 md:px-6 relative">
            <div className="max-w-3xl">
              <div className="inline-flex items-center gap-2 bg-[#cc1100]/15 border border-[#cc1100]/30 rounded-full px-4 py-1.5 mb-6">
                <i className="ri-information-fill text-[#d4a017] text-xs" />
                <span className="text-[#d4a017] text-xs font-semibold tracking-widest uppercase">
                  {t('About MrCuci', 'Tentang MrCuci')}
                </span>
              </div>
              <h1 className="text-4xl md:text-6xl font-black text-white leading-tight mb-6">
                <LinkedText>{t(
                  'About MrCuci Malaysia Online Casino — Trusted by 500,000+ Players',
                  'Tentang Kasino Dalam Talian MrCuci Malaysia — Dipercayai 500,000+ Pemain'
                )}</LinkedText>
              </h1>
              <p className="text-gray-300 text-base md:text-lg leading-relaxed mb-8 max-w-2xl">
                <LinkedText>{t(
                  'MrCuci Malaysia online casino was built for Malaysian players who want generous bonuses, fast MYR payouts, 5,000+ games, and a platform they can trust with their money.',
                  'Kasino dalam talian MrCuci Malaysia dibina untuk pemain Malaysia yang mahukan bonus murah hati, bayaran MYR pantas, 5,000+ permainan, dan platform yang boleh dipercayai dengan wang mereka.'
                )}</LinkedText>
              </p>
              <div className="flex flex-wrap gap-3">
                <RegisterLink
                  source="about_hero_join_free"
                  label={t('Join MrCuci Free', 'Sertai MrCuci Percuma')}
                  className="inline-flex items-center gap-2 font-bold px-7 py-3 rounded-lg text-sm shadow-[0_4px_20px_rgba(204,17,0,0.4)]"
                  style={{ background: 'linear-gradient(135deg, #cc1100, #ff2200)', color: 'white' }}
                >
                  <span>{t('Join MrCuci Free', 'Sertai MrCuci Percuma')}</span>
                  <i className="ri-arrow-right-line" />
                </RegisterLink>
                <RegisterLink
                  source="about_hero_view_bonuses"
                  label={t('View Bonuses', 'Lihat Bonus')}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="inline-flex items-center gap-2 font-bold px-7 py-3 rounded-lg text-sm border border-[#d4a017]/40 text-[#d4a017] hover:border-[#d4a017] transition-colors"
                >
                  <span>{t('View Bonuses', 'Lihat Bonus')}</span>
                  <i className="ri-gift-line" />
                </RegisterLink>
              </div>
            </div>
          </div>
        </section>

        <nav
          aria-label={t('About page contents', 'Kandungan halaman tentang')}
          className="border-b border-[#d4a017]/10"
          style={{ background: '#0d0101' }}
        >
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
            <h2 className="text-white font-black text-lg mb-4">
              {t('Explore this MrCuci guide', 'Terokai panduan MrCuci ini')}
            </h2>
            <div className="flex flex-wrap gap-2">
              {[
                ['#who-we-are', t('Who we are', 'Siapa kami')],
                ['#why-choose-mrcuci', t('Why choose MrCuci', 'Mengapa pilih MrCuci')],
                ['#mrcuci-values', t('Player values', 'Nilai pemain')],
                ['#mrcuci-history', t('Our journey', 'Perjalanan kami')],
                ['#mrcuci-player-guide', t('Player guide', 'Panduan pemain')],
              ].map(([href, label]) => (
                <a
                  key={href}
                  href={href}
                  className="rounded-full border border-[#d4a017]/20 px-4 py-2 text-xs font-semibold text-gray-300 hover:border-[#d4a017]/60 hover:text-[#d4a017] transition-colors"
                >
                  {label}
                </a>
              ))}
            </div>
          </div>
        </nav>

        {/* Stats bar */}
        <section className="border-b border-[#d4a017]/10" style={{ background: '#0d0101' }}>
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {trustStats.map((stat) => (
                <div key={stat.num} className="text-center">
                  <p
                    className="text-3xl md:text-4xl font-black mb-1 text-transparent bg-clip-text"
                    style={{ backgroundImage: 'linear-gradient(135deg, #d4a017, #f5c518)' }}
                  >
                    {stat.num}
                  </p>
                  <p className="text-gray-400 text-xs md:text-sm">{t(stat.en_label, stat.bm_label)}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Who we are */}
        <section id="who-we-are" className="py-14 md:py-20 scroll-mt-24">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <p className="text-[#d4a017] text-xs font-semibold tracking-widest uppercase mb-3">
                  {t('Who We Are', 'Siapa Kami')}
                </p>
                <h2 className="text-3xl md:text-4xl font-black text-white leading-tight mb-5">
                  {t(
                    'Why MrCuci is a trusted Malaysia online casino for local players',
                    'Mengapa MrCuci ialah kasino dalam talian Malaysia yang dipercayai pemain tempatan'
                  )}
                </h2>
                <div className="space-y-4 text-gray-400 text-sm leading-[1.9]">
                  <p>
                    <LinkedText>{t(
                      "MrCuci is Malaysia's #1 online casino platform, serving over 500,000 active members across the country. We were founded with one clear goal: to give Malaysian players the best possible online gaming experience, without the frustrations that plague other platforms.",
                      'MrCuci ialah platform kasino dalam talian #1 Malaysia, melayani lebih 500,000 ahli aktif di seluruh negara. Kami ditubuhkan dengan satu matlamat yang jelas: untuk memberi pemain Malaysia pengalaman permainan dalam talian yang terbaik, tanpa rasa kecewa yang menghantui platform lain.'
                    )}</LinkedText>
                  </p>
                  <p>
                    <LinkedText>{t(
                      "That means instant withdrawals processed in minutes, not days. It means a bonus programme that genuinely rewards loyalty, with four active promotions running at all times. It means a game library of 5,000+ titles from the world's best providers, all accessible from your phone without downloading anything.",
                      'Itu bermakna pengeluaran segera diproses dalam beberapa minit, bukan hari. Ia bermakna program bonus yang benar-benar memberi ganjaran kesetiaan, dengan empat promosi aktif berjalan setiap masa. Ia bermakna perpustakaan permainan lebih 5,000 tajuk dari pembekal terbaik dunia, semua boleh diakses dari telefon anda tanpa memuat turun apa-apa.'
                    )}</LinkedText>
                  </p>
                  <p>
                    <LinkedText>{t(
                      "Most importantly, it means a platform that treats your money and your data with the same care you expect from a licensed financial institution. MrCuci uses bank-grade encryption, supports all major Malaysian payment channels, and operates with a zero-tolerance policy on fraud.",
                      'Yang paling penting, ia bermakna platform yang melayan wang dan data anda dengan penjagaan yang sama seperti yang anda harapkan dari institusi kewangan berlesen. MrCuci menggunakan penyulitan gred bank, menyokong semua saluran pembayaran utama Malaysia, dan beroperasi dengan dasar sifar toleransi terhadap penipuan.'
                    )}</LinkedText>
                  </p>
                </div>
              </div>

              {/* Visual card */}
              <div className="grid grid-cols-2 gap-4">
                {[
                  { icon: 'ri-medal-fill', en: 'Malaysia #1 Casino', bm: 'Kasino #1 Malaysia', color: '#d4a017' },
                  { icon: 'ri-secure-payment-fill', en: 'Secure Payments', bm: 'Pembayaran Selamat', color: '#cc1100' },
                  { icon: 'ri-time-fill', en: 'Fast Withdrawals', bm: 'Pengeluaran Pantas', color: '#d4a017' },
                  { icon: 'ri-gamepad-fill', en: '5,000+ Games', bm: '5,000+ Permainan', color: '#cc1100' },
                ].map((item) => (
                  <div
                    key={item.en}
                    className="rounded-2xl p-6 flex flex-col items-center text-center border border-[#d4a017]/15 hover:border-[#d4a017]/35 transition-colors"
                    style={{ background: 'linear-gradient(135deg, #180303, #200404)' }}
                  >
                    <div
                      className="w-12 h-12 flex items-center justify-center rounded-xl mb-3"
                      style={{ background: `linear-gradient(135deg, ${item.color}22, ${item.color}44)`, border: `1px solid ${item.color}40` }}
                    >
                      <i className={`${item.icon} text-xl`} style={{ color: item.color }} />
                    </div>
                    <p className="text-white font-bold text-sm leading-snug">{t(item.en, item.bm)}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose MrCuci */}
        <section
          id="why-choose-mrcuci"
          className="py-14 md:py-20 border-y border-[#d4a017]/10"
          style={{ background: 'linear-gradient(180deg, #0d0101 0%, #120202 100%)' }}
        >
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <p className="text-[#d4a017] text-xs font-semibold tracking-widest uppercase mb-3">
                {t('Why MrCuci', 'Mengapa MrCuci')}
              </p>
              <h2 className="text-3xl md:text-4xl font-black text-white mb-4">
                {t(
                  '6 Reasons Malaysians Choose MrCuci Online Casino Malaysia',
                  '6 Sebab Rakyat Malaysia Memilih Kasino Dalam Talian MrCuci Malaysia'
                )}
              </h2>
              <p className="text-gray-400 text-sm max-w-xl mx-auto leading-relaxed">
                {t(
                  "We don't just say we're the best — here's exactly why 500,000+ players agree.",
                  'Kami tidak sekadar mengatakan kami yang terbaik — inilah sebab tepat mengapa 500,000+ pemain bersetuju.'
                )}
              </p>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {features.map((feat, idx) => (
                <div
                  key={feat.en_title}
                  className="rounded-2xl p-6 border border-[#d4a017]/10 hover:border-[#d4a017]/30 transition-all duration-300"
                  style={{ background: 'linear-gradient(135deg, #180303, #1e0404)' }}
                >
                  <div className="flex items-start gap-4 mb-4">
                    <div
                      className="w-10 h-10 flex items-center justify-center rounded-xl shrink-0"
                      style={{
                        background: `linear-gradient(135deg, ${feat.color}22, ${feat.color}44)`,
                        border: `1px solid ${feat.color}40`,
                      }}
                    >
                      <i className={`${feat.icon} text-lg`} style={{ color: feat.color }} />
                    </div>
                    <div>
                      <span
                        className="text-xs font-black mr-2"
                        style={{ color: feat.color }}
                      >
                        0{idx + 1}
                      </span>
                      <h3 className="inline text-white font-black text-sm md:text-base">
                        {t(feat.en_title, feat.bm_title)}
                      </h3>
                    </div>
                  </div>
                  <div className="h-px mb-4 bg-gradient-to-r from-[#d4a017]/20 to-transparent" />
                  <p className="text-gray-400 text-sm leading-[1.85]">
                    <LinkedText>{t(feat.en_desc, feat.bm_desc)}</LinkedText>
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Our Values */}
        <section id="mrcuci-values" className="py-14 md:py-20 scroll-mt-24">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <p className="text-[#d4a017] text-xs font-semibold tracking-widest uppercase mb-3">
                {t('Our Values', 'Nilai Kami')}
              </p>
              <h2 className="text-3xl md:text-4xl font-black text-white">
                {t('What Drives Everything We Do', 'Apa Yang Mendorong Semua Yang Kami Lakukan')}
              </h2>
            </div>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {values.map((val) => (
                <div
                  key={val.en_title}
                  className="rounded-2xl p-6 border border-[#d4a017]/10 hover:border-[#d4a017]/30 transition-all duration-300 text-center"
                  style={{ background: 'linear-gradient(135deg, #130202, #1a0303)' }}
                >
                  <div
                    className="w-14 h-14 flex items-center justify-center rounded-2xl mx-auto mb-4"
                    style={{ background: 'linear-gradient(135deg, rgba(212,160,23,0.15), rgba(204,17,0,0.15))', border: '1px solid rgba(212,160,23,0.25)' }}
                  >
                    <i className={`${val.icon} text-2xl text-[#d4a017]`} />
                  </div>
                  <h3 className="text-white font-black text-base mb-2">{t(val.en_title, val.bm_title)}</h3>
                  <p className="text-gray-500 text-xs leading-relaxed"><LinkedText>{t(val.en_desc, val.bm_desc)}</LinkedText></p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Timeline */}
        <section
          id="mrcuci-history"
          className="py-14 md:py-20 border-y border-[#d4a017]/10"
          style={{ background: 'linear-gradient(180deg, #0d0101 0%, #100101 100%)' }}
        >
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <p className="text-[#d4a017] text-xs font-semibold tracking-widest uppercase mb-3">
                {t('Our Journey', 'Perjalanan Kami')}
              </p>
              <h2 className="text-3xl md:text-4xl font-black text-white">
                {t('MrCuci Through the Years', 'MrCuci Sepanjang Tahun')}
              </h2>
            </div>
            <div className="relative">
              {/* vertical line */}
              <div
                className="absolute left-6 md:left-1/2 top-0 bottom-0 w-px"
                style={{ background: 'linear-gradient(180deg, #cc1100, #d4a017, transparent)', transform: 'translateX(-50%)' }}
              />
              <div className="space-y-8">
                {milestones.map((ms, idx) => (
                  <div
                    key={ms.year}
                    className={`relative flex items-start gap-6 md:gap-0 ${idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}
                  >
                    {/* dot */}
                    <div
                      className="absolute left-6 md:left-1/2 w-4 h-4 rounded-full border-2 border-[#d4a017] shrink-0 mt-1"
                      style={{ background: '#cc1100', transform: 'translateX(-50%)' }}
                    />

                    {/* content */}
                    <div className={`ml-14 md:ml-0 md:w-1/2 ${idx % 2 === 0 ? 'md:pr-12' : 'md:pl-12'}`}>
                      <div
                        className="rounded-2xl p-5 border border-[#d4a017]/15 hover:border-[#d4a017]/30 transition-colors"
                        style={{ background: 'linear-gradient(135deg, #180303, #1e0404)' }}
                      >
                        <span
                          className="text-xs font-black tracking-widest"
                          style={{ color: '#d4a017' }}
                        >
                          {ms.year}
                        </span>
                        <h3 className="text-white font-black text-base mt-1 mb-2">
                          {t(ms.en_title, ms.bm_title)}
                        </h3>
                        <p className="text-gray-400 text-sm leading-relaxed">
                          <LinkedText>{t(ms.en_desc, ms.bm_desc)}</LinkedText>
                        </p>
                      </div>
                    </div>

                    {/* spacer for opposite side */}
                    <div className="hidden md:block md:w-1/2" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Detailed player guide */}
        <section id="mrcuci-player-guide" className="py-14 md:py-20 scroll-mt-24">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <p className="text-[#d4a017] text-xs font-semibold tracking-widest uppercase mb-3">
              {t('Player Guide', 'Panduan Pemain')}
            </p>
            <h2 className="text-2xl md:text-3xl font-black text-white mb-5">
              {t(
                'What Malaysian players can expect from MrCuci online casino',
                'Apa yang pemain Malaysia boleh harapkan daripada kasino dalam talian MrCuci'
              )}
            </h2>
            <p className="text-gray-400 text-sm leading-[1.9] mb-8">
              <LinkedText>{t(
                'Choosing an online casino is easier when the important details are in one place. MrCuci combines a broad game catalogue, Ringgit-friendly payments, current promotions and bilingual assistance in a mobile-first experience designed around how Malaysian players deposit, play and withdraw.',
                'Memilih kasino dalam talian lebih mudah apabila butiran penting berada di satu tempat. MrCuci menggabungkan katalog permainan yang luas, pembayaran mesra Ringgit, promosi semasa dan bantuan dwibahasa dalam pengalaman mengutamakan mudah alih yang direka mengikut cara pemain Malaysia deposit, bermain dan membuat pengeluaran.'
              )}</LinkedText>
            </p>

            <div className="grid gap-5 md:grid-cols-2">
              <article className="rounded-2xl border border-[#d4a017]/10 p-6" style={{ background: 'linear-gradient(135deg, #180303, #1e0404)' }}>
                <h3 className="text-lg font-black text-white mb-3">
                  {t(
                    'Slots, live casino and fishing games in one lobby',
                    'Slot, kasino langsung dan permainan memancing dalam satu lobi'
                  )}
                </h3>
                <p className="text-gray-400 text-sm leading-[1.85] mb-4">
                  <LinkedText>{t(
                    'The MrCuci game lobby covers quick-play slots, feature-rich video slots, fishing arcade titles and live dealer tables. Players can compare providers and game styles without moving between separate platforms.',
                    'Lobi permainan MrCuci merangkumi slot pantas, slot video dengan pelbagai ciri, tajuk arked memancing dan meja peniaga langsung. Pemain boleh membandingkan pembekal serta gaya permainan tanpa berpindah antara platform berasingan.'
                  )}</LinkedText>
                </p>
                <h4 className="text-sm font-bold text-[#d4a017] mb-2">
                  {t('Designed for mobile browsers', 'Direka untuk pelayar mudah alih')}
                </h4>
                <p className="text-gray-500 text-xs leading-relaxed">
                  {t(
                    'The responsive interface works across iPhone and Android devices, allowing members to browse games, check promotions and manage their account without installing a separate app.',
                    'Antara muka responsif berfungsi pada peranti iPhone dan Android, membolehkan ahli melayari permainan, menyemak promosi dan mengurus akaun tanpa memasang aplikasi berasingan.'
                  )}
                </p>
              </article>

              <article className="rounded-2xl border border-[#d4a017]/10 p-6" style={{ background: 'linear-gradient(135deg, #180303, #1e0404)' }}>
                <h3 className="text-lg font-black text-white mb-3">
                  {t(
                    'MYR deposits, withdrawals and local payment access',
                    'Deposit MYR, pengeluaran dan akses pembayaran tempatan'
                  )}
                </h3>
                <p className="text-gray-400 text-sm leading-[1.85] mb-4">
                  <LinkedText>{t(
                    'MrCuci supports familiar Malaysian payment channels including FPX, Touch n\' Go, Grab Pay, Digi and Hotlink. Clear transaction steps help members understand minimums, verification and payout requirements before they submit a request.',
                    'MrCuci menyokong saluran pembayaran Malaysia yang biasa termasuk FPX, Touch n\' Go, Grab Pay, Digi dan Hotlink. Langkah transaksi yang jelas membantu ahli memahami minimum, pengesahan dan syarat bayaran sebelum menghantar permintaan.'
                  )}</LinkedText>
                </p>
                <h4 className="text-sm font-bold text-[#d4a017] mb-2">
                  {t('Account verification and payment safety', 'Pengesahan akaun dan keselamatan pembayaran')}
                </h4>
                <p className="text-gray-500 text-xs leading-relaxed">
                  {t(
                    'Members should keep their profile details accurate and use payment methods registered in their own name. Verification can be requested to protect account balances and withdrawals.',
                    'Ahli perlu memastikan butiran profil tepat dan menggunakan kaedah pembayaran yang didaftarkan atas nama sendiri. Pengesahan boleh diminta untuk melindungi baki akaun dan pengeluaran.'
                  )}
                </p>
              </article>

              <article className="rounded-2xl border border-[#d4a017]/10 p-6" style={{ background: 'linear-gradient(135deg, #180303, #1e0404)' }}>
                <h3 className="text-lg font-black text-white mb-3">
                  {t('Current MrCuci bonuses explained clearly', 'Bonus semasa MrCuci diterangkan dengan jelas')}
                </h3>
                <p className="text-gray-400 text-sm leading-[1.85] mb-4">
                  <LinkedText>{t(
                    'Current highlights include New Member Register Free RM88, Welcome Bonus 50%, Deposit RM200 Free RM200 and Monthly Competition Deposit Ranking RM1088. Each promotion has its own eligibility, game and turnover conditions.',
                    'Sorotan semasa termasuk Ahli Baharu Daftar Percuma RM88, Bonus Selamat Datang 50%, Deposit RM200 Percuma RM200 dan Pertandingan Bulanan Kedudukan Deposit RM1088. Setiap promosi mempunyai syarat kelayakan, permainan dan turnover tersendiri.'
                  )}</LinkedText>
                </p>
                <h4 className="text-sm font-bold text-[#d4a017] mb-2">
                  {t('Read the offer before claiming', 'Baca tawaran sebelum menuntut')}
                </h4>
                <p className="text-gray-500 text-xs leading-relaxed">
                  {t(
                    'Check claim limits, eligible games and withdrawal rules in the bonus centre so the offer matches the way you intend to play.',
                    'Semak had tuntutan, permainan layak dan peraturan pengeluaran di pusat bonus supaya tawaran sepadan dengan cara anda ingin bermain.'
                  )}
                </p>
              </article>

              <article className="rounded-2xl border border-[#d4a017]/10 p-6" style={{ background: 'linear-gradient(135deg, #180303, #1e0404)' }}>
                <h3 className="text-lg font-black text-white mb-3">
                  {t('Help, account information and safer play', 'Bantuan, maklumat akaun dan permainan lebih selamat')}
                </h3>
                <p className="text-gray-400 text-sm leading-[1.85] mb-4">
                  {t(
                    'English and Bahasa Malaysia support helps members resolve account, bonus and payment questions. Responsible gaming guidance also explains budgets, breaks, limits and self-exclusion options.',
                    'Sokongan Bahasa Inggeris dan Bahasa Malaysia membantu ahli menyelesaikan soalan akaun, bonus dan pembayaran. Panduan permainan bertanggungjawab turut menerangkan bajet, rehat, had dan pilihan pengecualian diri.'
                  )}
                </p>
                <h4 className="text-sm font-bold text-[#d4a017] mb-2">
                  {t('Continue reading', 'Teruskan membaca')}
                </h4>
                <p className="text-gray-500 text-xs leading-relaxed">
                  <Link to="/faq/" className="text-[#d4a017] hover:underline">FAQ</Link>
                  {', '}
                  <Link to="/terms/" className="text-[#d4a017] hover:underline">
                    {t('Terms & Conditions', 'Terma & Syarat')}
                  </Link>
                  {t(' and ', ' dan ')}
                  <Link to="/responsible-gaming/" className="text-[#d4a017] hover:underline">
                    {t('Responsible Gaming', 'Permainan Bertanggungjawab')}
                  </Link>
                  {t(' provide the detailed rules behind the platform.', ' menyediakan peraturan terperinci di sebalik platform.')}
                </p>
              </article>
            </div>
          </div>
        </section>

      </main>

      <Footer />
    </div>
  );
}
